module.exports = __webpack_public_path__ + "img/b-logo.27230c72.png";